import { createAction } from '@reduxjs/toolkit'

import { TReportEdition } from 'types/GlobalReport'

// tryGetAllReportEditions
export const getAll = createAction('get_all_report_editions')
export const getAllSuccess = createAction<TReportEdition[]>(
  'get_all_report_editions_success'
)
export const getAllFailed = createAction('get_all_report_editions_failed')

// tryCreateReportEdition
export const create = createAction('create_report_edition')
export const createSuccess = createAction<TReportEdition>(
  'create_report_edition_success'
)
export const createFailed = createAction('create_report_edition_failed')

// tryUpdateReportEdition
export const update = createAction('update_report_edition')
export const updateSuccess = createAction<TReportEdition>(
  'update_report_edition_success'
)
export const updateFailed = createAction('update_report_edition_failed')

// tryDeleteReportEdition
export const destroy = createAction('destroy_report_edition')
export const destroySuccess = createAction<string>(
  'destroy_report_edition_success'
)
export const destroyFailed = createAction('destroy_report_edition_failed')
